<app-home-title [title]="TItle" ></app-home-title>
<!-- <app-home-about></app-home-about> -->
<app-goverment></app-goverment>
<app-home-counter></app-home-counter>
<!-- <app-home-events></app-home-events> -->
<app-home-testimonial></app-home-testimonial>
<app-home-sponsers></app-home-sponsers>